import decode from 'jwt-decode';
export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        this.domain = domain || 'https://connect-back-end.scottguo.com/auth' // API server domain
        //this.domain = domain || 'http://localhost:8080' // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
        this.getToken = this.getToken.bind(this)
    }

    login(username, password) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/login`, {
            method: 'POST',
            body: JSON.stringify({
                username,
                password
            })
        }).then(res => {
            this.setToken(res.data.token) // Setting the token in localStorage
            console.log(res)
            //localStorage.setItem('token', res.token)
            return Promise.resolve(res);
        })
    }

    facebookLogin(){
        return this.fetch(`${this.domain}/facebook`, {
            method: 'GET',
        })
        .then(res => {
            return res.json();
        })
    }

    signup(username, password) {
        const form = {username:username, password:password}
        const formBody = Object.keys(form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(form[key])).join('&');
        return fetch(`${this.domain}/register`, {
            headers:{ 'Content-Type': 'application/x-www-form-urlencoded', 
            'Accept': 'application/x-www-form-urlencoded' 
            },
            method: 'POST',
            body: formBody
        }).then(response => console.log('Success:', response))
        .catch(error => console.error('Error:', error))
    }

    signupLead(leadData) {
        const url = 'https://connect-back-end.scottguo.com/api/user' // API server domain
        
        const headers={ 'Content-Type': 'application/json', 
        'Accept': 'application/json' 
        };

        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return fetch(url, {
            headers,
            method: 'POST',
            body: leadData
        }).then(response => console.log('Success:', response))
        .catch(error => console.error('Error:', error))
        ;
    }


    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }

    logout() {
        // Clear user token and profile data from localStorage
        fetch(`${this.domain}/logout`, {
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.getToken()
            },
            method: 'GET',
        }).then(res => {
            console.log(res.json())
        })
        localStorage.removeItem('id_token');
        localStorage.removeItem('username');
        localStorage.removeItem('hasLead');
        localStorage.removeItem('profile')
    }

    hasLead() {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            //'Content-Type': 'application/x-www-form-urlencoded'
        }
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return fetch('https://connect-back-end.scottguo.com/api/user', {
            headers,
            method: 'GET',
        })
        .then(res => {
            if(res.ok){
                localStorage.setItem('hasLead', 1);
                return res.json();
            } else {
                localStorage.setItem('hasLead', 0);
            }
        })
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        return decode(this.getToken());
    }


    fetch(url, options) {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            //'Content-Type': 'application/x-www-form-urlencoded'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/AuthService.js